// extracted by mini-css-extract-plugin
export var childrenContainer = "_ay-0";
export var virtualScrollArea = "_ay-1";